export const toNumberOrDefault = (
  value: number | string,
  defaultValue: number,
) => (Number.isNaN(+value) ? defaultValue : +value);
